import React from "react";
import type {VoidFunctionComponent} from "react";
import {useFilterGenreLogic} from "./FilterGenre.logic";
import {CheckboxListItem} from "../../../components/common/checkbox/CheckboxListItem";

export interface IFilterGenre {
  genreId: number;
}
export const FilterGenre: VoidFunctionComponent<IFilterGenre> = ({genreId}) => {
  const {title, isSelected, handleToggleOnClick} = useFilterGenreLogic(genreId);
  return (
    <CheckboxListItem
      label={`${title}`}
      onClick={handleToggleOnClick}
      isChecked={isSelected}
    />
  );
}
